import { AlertService } from '../../shared/services/alert.service';
import { OnInit } from '@angular/core';
import { ScaleRange } from '../../shared/models/scale-range';
import { AssessmentService } from '../../shared/services/assessment.service';
import { Router, ActivatedRoute } from '@angular/router';
var ScaleRangeNewComponent = /** @class */ (function () {
    function ScaleRangeNewComponent(assessmentService, alertService, router, route) {
        this.assessmentService = assessmentService;
        this.alertService = alertService;
        this.router = router;
        this.route = route;
        this.SAVE_TIME = 1500;
        this.ERROR_MESSAGE_TIME = 3000;
        this.range = this.getNewObject();
    }
    ScaleRangeNewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            var assessmentUid = params['uid'];
            var scaleId = params['scaleId'];
            _this.assessmentService.getAssessment(assessmentUid)
                .then(function (assessment) {
                _this.assessment = assessment;
                _this.scale = assessment.scales.find(function (s) { return s.id == scaleId; });
                if (!_this.scale) {
                    // TODO: stephen should we navigate back?? or do some kind of 404?
                    _this.router.navigate(["not-found"]);
                }
            })
                .catch(function (error) {
                console.error(error);
                _this.router.navigate(["not-found"]);
            });
        });
    };
    ScaleRangeNewComponent.prototype.getNewObject = function () {
        var obj = new ScaleRange();
        obj.id = this.assessmentService.newId();
        return obj;
    };
    Object.defineProperty(ScaleRangeNewComponent.prototype, "range", {
        get: function () {
            return this._range;
        },
        set: function (v) {
            this._range = v;
        },
        enumerable: true,
        configurable: true
    });
    ScaleRangeNewComponent.prototype.saveRange = function (range) {
        var _this = this;
        this.scale.addRange(range);
        this.isSaving = true;
        return this.assessmentService.saveAssessment(this.assessment).then(function (assessment) {
            _this.alertService.success("Range saved", _this.SAVE_TIME);
            _this.isSaving = false;
            return range;
        }).catch(function (error) {
            _this.isSaving = false;
            _this.alertService.error("An error occurred in saving. Please try again or contact support.", _this.ERROR_MESSAGE_TIME);
            console.error(error);
        });
    };
    ScaleRangeNewComponent.prototype.save = function () {
        var _this = this;
        this.saveRange(this.range).then(function (question) {
            setTimeout(function () {
                _this.router.navigate(["../", _this.range.id, "edit"], { relativeTo: _this.route, replaceUrl: true });
            }, _this.SAVE_TIME);
        });
    };
    ScaleRangeNewComponent.prototype.saveAndCreateNew = function () {
        var _this = this;
        this.saveRange(this.range).then(function (question) {
            _this.range = _this.getNewObject();
        });
    };
    return ScaleRangeNewComponent;
}());
export { ScaleRangeNewComponent };



// WEBPACK FOOTER //
// ./src/app/admin/scale-range-new/scale-range-new.component.ts.pre-build-optimizer.js